import userTypeToString from './userTypeToString';
import transformTypeString from './transformTypeString';
import transformTypeStringShort from './transformTypeStringShort';

export default {
    /** 用户类型中文 */
    userTypeToString,

    /** 发票类型中文显示 */
    transformTypeString,

    /** 发票类型中文显示(简写) */
    transformTypeStringShort
};



// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/entry/Language/index.ts